import { inject, Pipe, type PipeTransform } from '@angular/core';
import { AppService } from 'app/app.service';
import { RatingService } from 'app/services/rating/rating.service';

@Pipe({
    name: 'ratingColour',
    standalone: true,
})
export class RatingColourPipe implements PipeTransform {

    private appService = inject(AppService);
    private ratingService = inject(RatingService);
    private featureFlagThresholds = this.ratingService.getThresholdsFromString(this.appService?.features?.page?.replay?.thresholds);


    transform(value: number): string {
        return this.ratingService.getThresholdColour(value, this.featureFlagThresholds);
    }

}
